import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValuationRequestService } from '../../../shared/services/valuations-request.service';

import { UpserviceService } from 'src/app/shared/services/upservice.service';
import { ElasticSearchService } from 'src/app/shared/services/elastic-search.service';
import { Auth } from 'aws-amplify';
import { MarketService } from 'src/app/shared/services/market.service';

@Component({
  selector: 'app-edit-valuation-request',
  templateUrl: './edit-valuation-request.component.html',
  styleUrls: ['./edit-valuation-request.component.css']
})
export class EditValuationRequestComponent implements OnInit {
  isLoading: boolean = false;
  loading: boolean = false;
  editValuationRequestForm: FormGroup;
  name: string | undefined;
  valuationId: any;
  propertyId: any;
  display: boolean = false;
  // private fb: FormBuilder
  isSearchingProperties: boolean = false;
  propertiesResults: boolean = false;
  propertiesSearchResults: any = [];
  selectedProperty: any = {};
  selectedSponsor: any = {};
  displaySelectedProperty: boolean = false;
  propertySearchError: boolean = false;
  owner: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private ValuationRequestService: ValuationRequestService,
    private upService: UpserviceService,
    private elasticSearchService: ElasticSearchService,
    private marketService: MarketService,
  ) {
    this.getCurrentAuthenticatedUser();
    this.editValuationRequestForm = this.fb.group({
      description: [''],
      propertyName: [''],
      agencyName: [''],
      status: [''],
      creationDate: [''],
    });
  }

  recievedValuationRequest: any;

  customStylesValidated = false;

  ngOnInit(): void {
    this.isLoading = true;
    console.log('router: ', this.router);
    this.route.queryParams.subscribe((params) => {
      this.recievedValuationRequest = params;
      console.log('recievedValuationRequest: ', this.recievedValuationRequest);
      this.valuationId = this.recievedValuationRequest.valuationRequestId;
      this.propertyId = this.recievedValuationRequest.propertyId;
      console.log('this.recievedValuationRequest.category');
    });

    const formValues = {
      description: [
        this.recievedValuationRequest.description
          ? this.recievedValuationRequest.description
          : '',
      ],
      propertyName: [
        this.recievedValuationRequest.propertyName
          ? this.recievedValuationRequest.propertyName
          : '',
      ],
      agencyName: [
        this.recievedValuationRequest.agencyName
          ? this.recievedValuationRequest.agencyName
          : '',
      ],
      status: [
        this.recievedValuationRequest.status
          ? this.recievedValuationRequest.status
          : '',
      ],
      creationDate: [
        this.recievedValuationRequest.creationDate
          ? this.recievedValuationRequest.creationDate
          : '',
      ],
    };

    this.getPropertyById(this.recievedValuationRequest.propertyId);    //get property by Id
    setTimeout(() => {
      this.isLoading = false;
      this.editValuationRequestForm = this.fb.group(formValues); //populate form with current values
    }, 1000);

  }
  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  getPropertyById(propertyId: any) {
    this.isSearchingProperties = true;

    this.marketService.getPropertyById(propertyId).subscribe((data) => {
      this.isSearchingProperties = false;

      this.selectedProperty = data;
      this.displaySelectedProperty = true;
      this.propertiesResults = true;
      console.log("getPropertyById", this.selectedProperty);

    }, err => {
      this.isSearchingProperties = false;
      this.selectedProperty = {
        name: this.recievedValuationRequest.propertyName,
        propertyId: this.recievedValuationRequest.propertyId
      };
      this.displaySelectedProperty = true;
      this.propertiesResults = true;
      console.log("selectedProperty", this.selectedProperty);

      console.log(err);
    });

  }

  onSelectProperty(property: any, propertyId: any) {
    this.propertiesSearchResults = []; //hide the results
    property['propertyId'] = propertyId;
    console.log('selected Property: ', property);
    this.selectedProperty = property;
    this.displaySelectedProperty = true;

    this.editValuationRequestForm.patchValue({
      propertyName: property.name
    });
  }


  removeProperty() {
    this.editValuationRequestForm.patchValue({
      propertyName: ''
    });
    this.selectedProperty = {};
    this.propertiesResults = false;
    this.displaySelectedProperty = false;
  }

  onSearchProperties(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingProperties = true;

      this.elasticSearchService.searchProperty(event.target.value, this.owner).subscribe(
        (data) => {
          this.isSearchingProperties = false;
          this.propertiesResults = true; //display the results
          this.propertiesSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.propertySearchError = true;
          }
          // console.log('Elastic Search', data);
          // console.log('Search results: ', this.propertiesSearchResults);
        },
        (error) => {
          this.isSearchingProperties = false;
          // console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingProperties = false;
      if (Object.keys(this.selectedProperty).length === 0) {
        this.propertiesResults = false; //hide the results
      }
    }
  }

  onSubmitEditForm() {
    this.customStylesValidated = true;

    if (this.editValuationRequestForm.valid) {
      this.loading = true;

      const object = {
        // valuationRequestId: this.valuationId,
        propertyId: this.propertyId,
        creationDate: this.editValuationRequestForm.value.creationDate,
        description: this.editValuationRequestForm.value.description,
        propertyName: this.editValuationRequestForm.value.propertyName,
        status: this.editValuationRequestForm.value.status,
        agencyName: this.editValuationRequestForm.value.agencyName,
      };

      this.ValuationRequestService.editValuationRequests(
        object,
        this.valuationId
      ).subscribe(
        (data) => {
          console.log(data);
          setTimeout(() => {
            this.loading = false;
            this.router.navigate(['private-space/view-valuation-requests', {}]);
          }, 1000); 
        },
        (err) => {
          setTimeout(() => {
            this.loading = false;
            this.router.navigate(['private-space/view-valuation-requests', {}]);
          }, 1000); 
          console.log(err);
          
        }
      );
      console.log('Form submitted', this.editValuationRequestForm?.value);
    } else {
      this.display = true;
    }
  }

  onReset1() {}
}
